var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialSnapchatMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Snapchat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.69 0 0 2.69 0 6v12c0 3.31 2.69 6 6 6h12c3.31 0 6-2.69 6-6V6c0-3.31-2.69-6-6-6Zm1.34 16.57c-.74.41-1.22.36-1.6.61-.32.21-.13.66-.37.82-.29.2-1.14-.01-2.24.35-.91.3-1.48 1.16-3.12 1.16s-2.2-.86-3.12-1.16c-1.1-.36-1.95-.15-2.24-.35-.23-.16-.04-.61-.37-.82-.38-.24-.87-.2-1.6-.61-.47-.26-.2-.42-.05-.49 2.66-1.29 3.09-3.28 3.11-3.43.02-.18.05-.32-.15-.5-.19-.18-1.04-.7-1.27-.86-.39-.27-.56-.54-.43-.87.09-.23.3-.32.53-.32.07 0 .14 0 .21.02.43.09.84.31 1.08.36.03 0 .06.01.09.01.13 0 .17-.06.16-.21-.03-.47-.09-1.37-.02-2.22.1-1.17.48-1.75.92-2.26.21-.24 1.22-1.31 3.15-1.31s2.94 1.07 3.15 1.31c.45.51.82 1.09.92 2.26.07.85.01 1.76-.02 2.22-.01.15.04.21.16.21.03 0 .06 0 .09-.01.24-.06.65-.27 1.08-.36.07-.02.14-.02.21-.02.23 0 .44.09.53.32.13.33-.04.6-.43.87-.23.16-1.08.69-1.27.86-.2.18-.17.32-.15.5.02.15.44 2.14 3.11 3.43.16.08.42.24-.05.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSnapchatMono);
export default __webpack_public_path__ + "static/media/social-snapchat-mono.615f993cf54bb54809ffa3669a014c85.svg";
export { ForwardRef as ReactComponent };